import Lang from '/@/modules/core/app/services/Lang';
import Enum from '/@/modules/core/app/helpers/Enum';
import EstateJurisdictionLang from '/@/modules/predefined/services/EstateJurisdictionLang';

export class FuneralPreArrangementFinalDispositionType extends Enum {
  static BURIAL = {
    key: 'burial',
    get value() {
      return Lang.t('asset.burial');
    }
  };

  static CREMATION = {
    key: 'cremation',
    get value() {
      return Lang.t('asset.cremation');
    }
  };

  static LET_EXECUTOR_DECIDE = {
    key: 'let_executor_decide',
    get value() {
      return Lang.t('asset.let-executor-my', { executor: EstateJurisdictionLang.executor });
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };

  static getValuesWithoutOther() {
    return [
      FuneralPreArrangementFinalDispositionType.BURIAL,
      FuneralPreArrangementFinalDispositionType.CREMATION,
      FuneralPreArrangementFinalDispositionType.LET_EXECUTOR_DECIDE
    ];
  }
}
